/*/
 * Swiper v8
/*/
	import Swiper, { Autoplay, Lazy, Navigation, Pagination } from 'swiper';

	const siteSwiperIndexCount = document.querySelectorAll('[site-swiper-index] .swiper-slide').length
	const siteSwiperIndex = new Swiper('[site-swiper-index]', {
		modules: [Navigation, Pagination, Lazy, Autoplay],
		loop: siteSwiperIndexCount > 1 ? true : false,
		speed: 750,
		threshold: 5,
		autoHeight: false,
		centerInsufficientSlides: true,
		grabCursor: true,
		lazy: {
			loadPrevNext: true,
		},
		autoplay: {
			delay: 5000,
			disableOnInteraction: true
		},
		pagination: {
			el: '.swiper-index-pagination',
			clickable: true,
			lockClass: 'd-none'
		},
		navigation: {
			nextEl: '.swiper-index-next',
			prevEl: '.swiper-index-prev',
			lockClass: 'd-none'
		}
	})

	const siteSwiperCertifications = new Swiper('[site-swiper-certifications]', {
		modules: [Navigation, Pagination, Lazy, Autoplay],
		loop: true,
		speed: 750,
		threshold: 5,
		slidesPerView: 2,
		slidesPerGroup: 2,
		spaceBetween: 40,
		autoHeight: false,
		grabCursor: true,
		centerInsufficientSlides: true,
		lazy: {
			loadPrevNext: true,
		},
		autoplay: {
			delay: 2000,
			disableOnInteraction: true
		},
		pagination: {
			el: '.swiper-certifications-pagination',
			clickable: true,
			lockClass: 'd-none'
		},
		navigation: {
			nextEl: '.swiper-certifications-next',
			prevEl: '.swiper-certifications-prev',
			lockClass: 'd-none'
		},
		breakpoints: {
			1200: {
				spaceBetween: 60,
				slidesPerView: 5,
				slidesPerGroup: 1,
			},
			992: {
				spaceBetween: 60,
				slidesPerView: 4,
				slidesPerGroup: 1,
			},
			480: {
				spaceBetween: 50,
				slidesPerView: 3,
				slidesPerGroup: 3,
			}
		}
	})

	const siteSwiperFaq = new Swiper('[site-swiper-categories]', {
		modules: [Navigation, Pagination],
		loop: false,
		speed: 750,
		threshold: 5,
		slidesPerView: 2,
		spaceBetween: 32,
		autoHeight: false,
		grabCursor: true,
		centerInsufficientSlides: true,
		pagination: {
			el: '.swiper-faq-pagination',
			clickable: true,
			lockClass: 'd-none'
		},
		navigation: {
			nextEl: '.swiper-faq-next',
			prevEl: '.swiper-faq-prev',
			lockClass: 'd-none'
		},
		breakpoints: {
			1200: {
				spaceBetween: 60,
				slidesPerView: 5,
			},
			992: {
				spaceBetween: 60,
				slidesPerView: 4,
			},
			501: {
				spaceBetween: 50,
				slidesPerView: 3,
			}
		}
	})
